export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly code: string,
    public readonly details?: unknown
  ) {
    super(message);
  }
}

let csrfToken = "";

export function setCsrfToken(value: string | null | undefined) {
  csrfToken = value || "";
}

export async function apiRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  const method = (init.method || "GET").toUpperCase();
  if (init.body && !(init.body instanceof FormData) && !headers.has("content-type")) headers.set("content-type", "application/json");
  if (!["GET", "HEAD", "OPTIONS"].includes(method) && csrfToken) headers.set("x-csrf-token", csrfToken);
  const response = await fetch(path, { ...init, headers, credentials: "same-origin" });
  const contentType = response.headers.get("content-type") || "";
  const payload: unknown = contentType.includes("application/json") ? await response.json() : await response.text();
  if (!response.ok) {
    const body = payload && typeof payload === "object" && "error" in payload ? payload.error : null;
    const error = body && typeof body === "object" ? body : null;
    const message = error && "message" in error && typeof error.message === "string" ? error.message : `Request failed (${response.status}).`;
    const code = error && "code" in error && typeof error.code === "string" ? error.code : "REQUEST_FAILED";
    const details = error && "details" in error ? error.details : undefined;
    throw new ApiError(message, response.status, code, details);
  }
  return payload as T;
}

export function jsonBody(value: unknown) {
  return JSON.stringify(value);
}
